{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Übernehmen",
    "CLEAR_BUTTON": "Leeren",
    "DATE_RANGE_INPUT": {
      "START": "Startdatum",
      "END": "Enddatum"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATUMSSPANNE",
      "LAST_7_DAYS": "Letzte 7 Tage",
      "LAST_30_DAYS": "Letzte 30 Tage",
      "LAST_3_MONTHS": "Letzte 3 Monate",
      "LAST_6_MONTHS": "Letzte 6 Monate",
      "LAST_YEAR": "Letztes Jahr",
      "CUSTOM_RANGE": "Benutzerdefinierter Zeitraum",
      "TODAY": "Heute",
      "YESTERDAY": "Gestern"
    }
  }
}
